import * as React from 'react';

const MediaBody: React.FC = ({ children }) => <div className="media-body">{children}</div>;

const Media: React.FC = ({ children }) => <div className="media">{children}</div>;

const Combined = Object.assign(Media, { Body: MediaBody });
export { Combined as Media };
